import React from 'react';

interface ExternalLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * ExternalLink component ensures all external links open in a new tab
 * with proper security attributes (noopener noreferrer)
 */
const ExternalLink: React.FC<ExternalLinkProps> = ({ 
  href, 
  children, 
  className, 
  style, 
  ...otherProps 
}) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      style={style}
      {...otherProps}
    >
      {children}
    </a>
  );
};

export default ExternalLink;